import { render, staticRenderFns } from "./ruleAdder.vue?vue&type=template&id=4e77e034&"
import script from "./ruleAdder.vue?vue&type=script&lang=ts&"
export * from "./ruleAdder.vue?vue&type=script&lang=ts&"
import style0 from "./ruleAdder.vue?vue&type=style&index=0&id=4e77e034&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports